export default "__VITE_ASSET__MkTxTzfP__"